<template>
  <div>
    <save-engagement-tool
      :pageHeadingInfo="pageHeadingInfo"
      :leftToolSummary="leftToolSummary"
      :rightToolSummary="rightToolSummary"
      :chartTabContent="chartTabContent"
      :chartProperties="chartProperties"
      :selectedComponent="selectedtabComponent"
      :chartData="chartGraphData"
      :fieldInfo="fieldInfo"
      @cancelInstance="cancelInstance"
      @saveInstance="saveInstance"
      @onBack="onBack"
      @onChangeChartTab="onChangeChartTab"
    ></save-engagement-tool>
    <confirmation-dialog
      v-for="dialog in confirmationDialogList"
      :key="dialog.id"
      :dialog="dialog"
      @buttonclick="dialogButtonClock"
    ></confirmation-dialog>
  </div>
</template>

<script>
import { SaveEngagementTool } from "../../component/loan";
import { ConfirmationDialog } from "../../component/tool";
import { LoanEngagementTool, UserEvent } from "../../mixin";
import { ICELoanIntegration } from "../../mixin";
import { LoanSelected, SaveAsAction } from "../../helpers/userEvent";
import {
  GET_ICE_API_RESPONSE,
  GET_LOAN_CHART_MODEL,
  SET_ICE_API_RESPONSE,
  SET_LOAN_CHART_MODEL,
  GET_SELECTED_LIABLITY_INFORMATION,
  SET_NOTIFICATION_SUMMARY,
  GET_LIABLITY_INFORMATION,
  GET_ICE_PROJECTION_MODEL,
  SET_LOADER_VISIBILITY,
} from "../../helpers/vuex-constants";
import { CommonHelper } from "../../helpers";
import { mapGetters, mapActions } from "vuex";
import { LoanService } from "../../services";
export default {
  components: {
    SaveEngagementTool,
    ConfirmationDialog,
  },
  data() {
    return {
      fieldInfo: {
        label: "Loan Name",
        error: false,
        errorText: [],
        value: "",
        maxValue: 60,
      },

      pageHeadingInfo: {
        heading: "Name the instance",
        headingIconText: " test hover",
        subHeading: "Make it short and descriptive so you can easily identify",
      },

      confirmationDialogList: [
        {
          toggle: false,
          id: 1,
          message: "You are about to discard the changes you have made.",
          title: "Discard Changes",
          leftButtons: [],
          rightButtons: [
            {
              text: "Discard",
              variation: "secondary",
              emitevent: "cancelButtonDialogDiscard_Click",
              id: 2,
            },
            {
              text: "Save",
              variation: "primary",
              emitevent: "cancelButtonDialogSave_Click",
              id: 3,
            },
          ],
        },
      ],
    };
  },
  mixins: [LoanEngagementTool, ICELoanIntegration, UserEvent],
  mounted() {
    this.chartData.barChartdata = this.loanModel.barchartData.data;
    this.chartData.areaChartdata = this.loanModel.areaChartData.data;
    this.projectionYear.Value = this.selectedLoanData.projectionYear;
    this.ResetBarChartProperties();
    this.ResetAreaChartProperties();
    this.onChangeChartTab("chart-area");
    this.rightToolSummary = [
      {
        key: "Total Loan Repayment",
        value: this.loanModel.totalLoanRepayment,
      },
      { key: "Total Interest", value: this.loanModel.totalInterest },
      { key: "Loan Paid In", value: this.loanModel.LoanPaindId },
    ];
    this.setLoanName();
  },
  async created() {},
  computed: {
    ...mapGetters("loan", {
      selectedLoanData: GET_SELECTED_LIABLITY_INFORMATION,
      iceApiModel: GET_ICE_API_RESPONSE,
      loanModel: GET_LOAN_CHART_MODEL,
      getLiablityInformation: GET_LIABLITY_INFORMATION,
      getIceProjectionModel: GET_ICE_PROJECTION_MODEL,
    }),
  },
  methods: {
    ...mapActions({
      setLoaderVisibility: SET_LOADER_VISIBILITY,
    }),
    setLoanName() {
      if (
        this.selectedLoanData.liabilityGuid ==
        "00000000-0000-0000-0000-000000000000"
      ) {
        this.fieldInfo.value = "";
      } else {
        this.fieldInfo.value = `${CommonHelper.convertAmountIntoCurrency(
          this.selectedLoanData.outstandingAmount
        )} at ${CommonHelper.addConstantSymbolInNumber(
          this.selectedLoanData.interestRate,
          "%"
        )}, Repayment of ${CommonHelper.convertAmountIntoCurrency(
          this.selectedLoanData.repaymentAmount
        )}`;
      }
    },

    cancelInstance() {
      this.confirmationDialogList[0].toggle = true;
    },
    dialogButtonClock(function_name) {
      this[function_name]();
    },
    saveInstance() {
      this.saveData();
    },
    onBack() {
      this.$router.push({ name: "loan-engagement-tool" });
    },
    cancelButtonDialogDiscard_Click() {
      this.$router.push({ name: "loan-engagement-tool" });
    },

    ValidateInstanceName() {
      let instanceName = this.fieldInfo.value;
      if (this.fieldInfo.value == "" || this.fieldInfo.value.trim() == "") {
        this.fieldInfo.error = true;
        this.fieldInfo.value = "";
        this.fieldInfo.errorText = ["Please Enter Instance Name"];
        return false;
      }
      var isExistName = this.getLiablityInformation.findIndex(
        (sr) =>
          sr.description.toUpperCase().trim() ==
          instanceName.toUpperCase().trim()
      );
      if (isExistName >= 0) {
        this.fieldInfo.error = true;
        this.fieldInfo.errorText = ["Instance Name aleady exist."];
        return false;
      }
      return true;
    },
    async saveData() {
      let isValid = this.ValidateInstanceName();
      let isUpdate = 0;
      if (isValid) {
        this.selectedLoanData.description = this.fieldInfo.value;
        let saveModel = this.createLoanModel(this.selectedLoanData);
        let iceProjectionModel = this.getIceProjectionModel;
        this.setLoaderVisibility(true);
        var apiResponse = await LoanService.saveAsLoanInformation(
          saveModel,
          iceProjectionModel
        );
        this.setLoaderVisibility(false);
        this.saveUserSession(
          LoanSelected,
          SaveAsAction,
          saveModel.loanTypeId + ""
        );
        this.saveLoanData(apiResponse, isUpdate);
      }
    },
    async cancelButtonDialogSave_Click() {
      this.saveData();
    },

    ...mapActions("loan", {
      setIceApiResponse: SET_ICE_API_RESPONSE,
      setLoanChartModel: SET_LOAN_CHART_MODEL,
    }),
    ...mapActions({
      setNotificationSummary: SET_NOTIFICATION_SUMMARY,
    }),
  },
  destroyed() {
    this.setIceApiResponse({});
    this.setLoanChartModel({});
  },
};
</script>

<style lang="scss" scoped></style>
